import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { bookingInfo } from '../../booking/book.helper';
import { CleintService } from '../../../../../shared/services/client.service';
@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
})
export class Step2Component implements OnInit, OnDestroy {
  @Input('updateParentModel')
  updateParentModel!: (
    part: Partial<bookingInfo>,
    isFormValid: boolean
  ) => void;
  TaratanTypeform!: FormGroup;
  @Input()
  defaultValues=[];
  @Input() siblings: [];
  private unsubscribe: Subscription[] = [];

  constructor(private fb: FormBuilder, private cleintService: CleintService,) {}

  ngOnInit() {
    console.log("this.siblings")
    console.log(this.siblings)
    this.initForm();
    this.updateParentModel({}, this.checkForm());

  }

  
  initForm() {
    this.TaratanTypeform = this.fb.group({

      court_id: [null, [Validators.required]],
    });

    const formChangesSubscr = this.TaratanTypeform.valueChanges.subscribe((val) => {
      this.updateParentModel(val, this.checkForm());
    });
    this.unsubscribe.push(formChangesSubscr);
  }

  checkForm() {
    return !this.TaratanTypeform.get('court_id')?.hasError('required');
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }


}
